import { render, staticRenderFns } from "./PanelCompetitionMap.vue?vue&type=template&id=4139be88&scoped=true&"
import script from "./PanelCompetitionMap.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionMap.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionMap.vue?vue&type=style&index=0&id=4139be88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4139be88",
  null
  
)

export default component.exports